import React, { useEffect, useState } from "react";
import { action, API, controller } from "../../../api/api";
import { formatDate, ToFormData } from "../../../hooks/Method";
import { useAppContext } from "context";
import { Snackbar } from "../../../layout";
import dayjs from "../../../utils/dayjs";
import { useTranslation } from "react-i18next";
import {
  LoginRounded,
  LogoutRounded,
  FiberManualRecordRounded,
} from "@mui/icons-material";

const UserCheckInOut = ({ open }) => {
  const { authUser, bizContext } = useAppContext();
  const { t } = useTranslation();
  const [userCheckInOut, setUserCheckInOut] = useState({});
  const [snackbar, setSnackbar] = useState({
    show: false,
    type: "error",
    msg: "",
  });

  useEffect(() => {
    if (authUser && authUser.id && open) {
      API(controller.UserCheckInOut + action.GetByAuthUser).get((res) => {
        if (res && res.status === 200 && res.result && res.result.id) {
          setUserCheckInOut({ ...res.result });
        }
      });
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authUser, open]);

  const handleCheckIn = () => {
    API(controller.UserCheckInOut + action.Post).post(
      ToFormData({
        checkIn: new Date().toISOString(),
        companyId: bizContext?.companyId || 0,
        outletId: bizContext?.outletId || 0,
      }),
      (res) => {
        if (res && res.status === 201) {
          setUserCheckInOut({ ...res.result });
          setSnackbar({
            show: true,
            type: "success",
            msg: res.msg,
          });
        }
      }
    );
  };

  const handleCheckOut = () => {
    API(controller.UserCheckInOut + action.Put).put(
      ToFormData({
        id: userCheckInOut.id,
        checkOut: new Date().toISOString(),
      }),
      (res) => {
        if (res && res.status === 200) {
          setUserCheckInOut({});
          setSnackbar({
            show: true,
            type: "success",
            msg: res.msg,
          });
        }
      }
    );
  };

  const isClockedIn = !!userCheckInOut.id;

  return (
    <>
      <div className="flex items-center justify-between px-5 py-4 border-b">
        {/* Status info */}
        <div className="flex items-center gap-3 min-w-0">
          <FiberManualRecordRounded
            sx={{ fontSize: 10 }}
            className={isClockedIn ? "text-green-500 animate-pulse" : "text-gray-300"}
          />
          <div className="grid gap-0.5 min-w-0">
            <span
              className={`text-[13px] font-semibold ${
                isClockedIn ? "text-gray-700" : "text-gray-400"
              }`}
            >
              {isClockedIn ? t("youAreClockedIn") : t("youAreClockedOut")}
            </span>
            {isClockedIn ? (
              <span className="text-[11px] text-gray-400 truncate">
                {dayjs.utc(userCheckInOut.checkIn).local().fromNow()}
                {" — "}
                {formatDate(userCheckInOut.checkIn)}
              </span>
            ) : (
              <span className="text-[11px] text-gray-300">--:--</span>
            )}
          </div>
        </div>

        {/* Action button */}
        {isClockedIn ? (
          <button
            onClick={handleCheckOut}
            className="flex items-center gap-1.5 ml-4 px-3 py-1.5 rounded text-red-500 !bg-red-50 hover:!bg-red-100 transition-colors text-[12px] font-medium shrink-0"
          >
            <LogoutRounded sx={{ fontSize: 15 }} />
            {t("checkOut")}
          </button>
        ) : (
          <button
            onClick={handleCheckIn}
            className="flex items-center gap-1.5 ml-4 px-3 py-1.5 rounded text-green-600 !bg-green-50 hover:!bg-green-100 transition-colors text-[12px] font-medium shrink-0"
          >
            <LoginRounded sx={{ fontSize: 15 }} />
            {t("checkIn")}
          </button>
        )}
      </div>
      {snackbar && (
        <Snackbar
          autoHideDuration={2000}
          snackbar={snackbar}
          setSnackbar={setSnackbar}
          vertical="bottom"
          horizontal="right"
        />
      )}
    </>
  );
};

export default UserCheckInOut;
